import React from 'react';
// import PropTypes from 'prop-types';

import { Grid, Cell } from '../../base/styled';

import {
  NumberWidget,
  ThreeSlotListWidget,
  ListWidget,
  LabelWidget,
} from '../../widgets';

const ConvivaDanySummary = (props) => {
  const {
    title,
    tops: {
      error = null,
      data: {
        topShows = {},
        topSvod = {},
        // topTvod = {},
        topChannels = {},
        topDevices = {},
        uniques = {},
        spi = {}
      } = {},
    } = {},
  } = props;

  return (
    <div className="dashboard">
      <Grid columns={4} rows="20px 220px minmax(70%, 90%)" alignContent="stretch" style={{ height: '100%' }}>
        <Cell width={4}>
          <LabelWidget input={{ data: { title } }} />
        </Cell>
        <Cell>
          <NumberWidget input={{ error, data: spi }} />
        </Cell>
        <Cell>
          <div>-</div>
        </Cell>
        <Cell>
          <NumberWidget input={{ error, data: uniques }} />
        </Cell>
        <Cell>
          <div>-</div>
        </Cell>
        {/* <Cell>
          <div>-</div>
        </Cell> */}
        <Cell>
          <ThreeSlotListWidget input={{ error, data: topChannels }} />
        </Cell>
        <Cell>
          <ThreeSlotListWidget input={{ error, data: topShows }} />
        </Cell>
        <Cell>
          <ListWidget input={{ error, data: topSvod }} />
        </Cell>
        {/* <Cell>
          <ThreeSlotListWidget input={{ error, data: topTvod }} />
        </Cell> */}
        <Cell>
          <ThreeSlotListWidget input={{ error, data: topDevices }} />
        </Cell>
      </Grid>
    </div>
  );
};

ConvivaDanySummary.defaultProps = null;

// ConvivaDanySummary.propTypes = {
//   title: PropTypes.string,
//   topChannels: PropTypes.shape(ThreeSlotListWidget.propTypes),
//   topShows: PropTypes.shape(ThreeSlotListWidget.propTypes),
//   topSvod: PropTypes.shape(ThreeSlotListWidget.propTypes),
//   topTvod: PropTypes.shape(ThreeSlotListWidget.propTypes),
//   topDevices: PropTypes.shape(ThreeSlotListWidget.propTypes),
// };

export default ConvivaDanySummary;
